import { Builder } from '@builder.io/react'
import React from 'react'
import './slider-text.css'
import Slider from 'react-slick'

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'

interface Image {
  // cloudinaryImage: any
  builderImage: any
  imgAltText: string
}
interface Props {
  backgroundColor: string
  // cloudinaryNutritionerImage: any
  builderNutritionistImage: any
  builderImage: any
  nutritionerImgAltText: string
  mainDescription: string
  mainDescriptionColor: string
  foodImages: Image[]
  showArrow: boolean
}

function SampleNextArrow(props: any) {
  const { className, style, onClick } = props
  return (
    <ChevronRightIcon onClick={onClick} className={`${className} slider-text-chevron-right h-2 sm:h-6`} style={style} />
  )
}

function SamplePrevArrow(props: any) {
  const { className, style, onClick } = props
  return (
    <ChevronLeftIcon onClick={onClick} className={`${className} slider-text-chevron-left h-2 sm:h-6`} style={style} />
  )
}

const SliderText = ({
  backgroundColor,
  mainDescription,
  mainDescriptionColor,
  // cloudinaryNutritionerImage,
  builderNutritionistImage,
  builderImage,
  nutritionerImgAltText = '',
  foodImages,
  showArrow
}: Props) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  }

  const getSlideItems = () => {
    return foodImages.map((item: Image, i: number) => {
      return (
        <div key={i} className="custom-slider-item w-full">
          <CdnImage
            className="slider-image object-cover"
            url={item.builderImage}
            alt={item.imgAltText}
            steps={[100, 200, 400]}
          />

          {/* {item.builderImage ? (
            <CdnImage
              className="slider-image object-cover"
              url={item.builderImage}
              alt={item.imgAltText}
              steps={[100, 200, 400]}
            />
          ) : (
            <CloudinaryImage
              className="slider-image object-cover"
              publicId={item.cloudinaryImage?.public_id}
              loading="lazy"
              alt={item.imgAltText}
              steps={[100, 200, 400]}
            />
          )} */}
        </div>
      )
    })
  }

  return (
    <div className="slider-text" style={{ backgroundColor: backgroundColor || '#f9f5f1' }}>
      <div className="slider-text-container mx-auto grid max-w-7xl gap-8 py-4 px-0 sm:grid-cols-1 sm:px-2 md:grid-cols-2 lg:px-4">
        <div className="slider-text-container-left relative">
          {showArrow && (
            <img
              className="absolute z-40 hidden lg:block"
              style={{ top: '1rem', left: '20%' }}
              src={'self-drawing-arrow-2.svg'}
              alt="Arrow 2"
            />
          )}
          {showArrow && (
            <span
              className="font-third absolute absolute z-40 hidden text-3xl lg:block"
              style={{ top: '1.5rem', left: '40%' }}
            >
              Scroll through Bianca's ingredient list
            </span>
          )}
          <div className="flex items-center justify-center">
            <Slider {...settings} className="slider-text-container-left-slider relative">
              {getSlideItems()}
            </Slider>
          </div>
        </div>
        <div className="slider-text-container-right">
          <CdnImage
            className="h-auto w-full"
            url={builderNutritionistImage}
            alt={nutritionerImgAltText}
            steps={[700, 600]}
          />
          {/* {builderNutritionistImage ? (
            <CdnImage
              className="h-auto w-full"
              url={builderNutritionistImage}
              alt={nutritionerImgAltText}
              steps={[700, 600]}
            />
          ) : (
            <CloudinaryImage
              className="h-auto w-full"
              publicId={cloudinaryNutritionerImage?.public_id}
              alt={nutritionerImgAltText}
              steps={[700, 600]}
              autoFormat={false}
            />
          )} */}
          <div
            className="break-words pt-3.5 font-serif font-normal"
            style={{ color: mainDescriptionColor || '#000000' }}
          >
            {mainDescription}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SliderText

Builder.registerComponent(SliderText, {
  name: 'SliderText',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#f9f5f1'
    },
    // {
    //   name: 'cloudinaryNutritionerImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderNutritionistImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },

    {
      name: 'nutritionerImgAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'mainDescription',
      type: 'text',
      defaultValue: 'Text Text'
    },
    {
      name: 'mainDescriptionColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'foodImages',
      type: 'list',
      defaultValue: [
        {
          imgSrc: null,
          imgAltText: ''
        }
      ],
      subFields: [
        // {
        //   name: 'cloudinaryImage',
        //   type: 'cloudinaryImageEditor'
        // },
        {
          name: 'builderImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
        {
          name: 'imgAltText',
          type: 'text',
          defaultValue: ''
        }
      ]
    },
    {
      name: 'showArrow',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
